import { ReactElement, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './RealSizeControl.module.scss';
import { useAppDispatch, useAppSelector } from '@customer/store/hooks';
import { setShowObjectScaleMarkers } from '@customer/store/slices/investigationGuiSlice';
import { VdsCheckbox } from '@volt/volt-extended-components-react';
import { CheckboxEvent, VdsCheckboxCustomEvent } from '@volt/volt-basic-components';

export const RealSizeControl = (): ReactElement => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const showObjectScaleMarkers = useAppSelector(
    state => state.investigationGui.showObjectScaleMarkers,
  );

  const onCheckboxChange = useCallback(
    (event: VdsCheckboxCustomEvent<CheckboxEvent>) => {
      dispatch(setShowObjectScaleMarkers(event.detail.isChecked()));
    },
    [dispatch],
  );

  return (
    <div className={`${styles.controlGroup} theme-light`}>
      <VdsCheckbox
        id="show-object-scale-markers"
        labelValue={t('Display object scale markers')}
        size="medium"
        checked={showObjectScaleMarkers}
        onCheckboxChange={onCheckboxChange}
      />
    </div>
  );
};
